import { createSlice } from "@reduxjs/toolkit";
import {
  showEmployee,
  showEmployeeByOid,
  getEmployeeByDeclarant,
} from "../actions";

const initialState = {
  employee: [],
  loading: false,
  employeesDeclarant: [],
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {},
  extraReducers: {
    [showEmployee.pending]: (state) => {
      state.loading = true;
    },
    [showEmployee.fulfilled]: (state, action) => {
      state.employee = action.payload || [];
      state.loading = false;
    },
    [showEmployee.rejected]: (state, action) => {
      state.loading = false;
    },

    // GET EMP BY OID
    [showEmployeeByOid.pending]: (state) => {
      state.loading = true;
    },
    [showEmployeeByOid.fulfilled]: (state, action) => {
      state.employee = action.payload || [];
      state.loading = false;
    },
    [showEmployeeByOid.rejected]: (state, action) => {
      state.loading = false;
    },

    // GET EMP BY DECLARANT
    [getEmployeeByDeclarant.pending]: (state) => {
      state.loading = true;
    },
    [getEmployeeByDeclarant.fulfilled]: (state, action) => {
      state.employeesDeclarant = action.payload || [];
      state.loading = false;
    },
    [getEmployeeByDeclarant.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const responseEmployee = (state) => state.employee;

export default employeeSlice.reducer;
